import React, { useState, useRef } from 'react';
import { variables } from 'src/Tenants';
import Select from 'react-select';
import Icon from '../Icon';

interface InboxMenuProps {
  onSelectType: (type: string) => void;
  type: string;
  showGeneral: boolean;
}

const InboxMenu = ({ onSelectType, type, showGeneral }: InboxMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // Create options array for the react-select component
  const getOptions = () => {
    const options = [];

    if (showGeneral) {
      options.push({ value: 'General', label: 'General' });
    }

    options.push({
      value: 'Service Request',
      label: variables.serviceRequest,
    });

    return options;
  };

  const handleChange = (selectedOption: any) => {
    if (selectedOption) {
      onSelectType(selectedOption.value);
    }
    setIsOpen(false);
  };

  const handleIconClick = () => {
    setIsOpen(!isOpen);
  };

  const generalType =
    type === 'General' || type === 'Service Request' ? 'active' : '';

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '30px',
      fontSize: '14px',
      display: 'none', // Hide the control part and only show the menu
    }),
    menu: (provided: any) => ({
      ...provided,
      width: '150px',
      zIndex: 9999,
      marginTop: '5px',
    }),
    menuList: (provided: any) => ({
      ...provided,
      padding: '0',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      cursor: 'pointer',
      backgroundColor: state.isSelected ? '#f5f5f5' : 'white',
      color: '#333',
      fontSize: '14px',
      padding: '8px 12px',
      '&:hover': {
        backgroundColor: '#f0f0f0',
      },
    }),
  };

  return (
    <div className="inbox-menu-container">
      <a onClick={handleIconClick} className={generalType}>
        <Icon glyph="edit" weight="light" size="small" />
      </a>
      {isOpen && (
        <div className="inbox-menu-select-container">
          <Select
            options={getOptions()}
            onChange={handleChange}
            menuIsOpen={true}
            autoFocus={true}
            backspaceRemovesValue={false}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            placeholder=""
            styles={customStyles}
            tabSelectsValue={false}
            className="inbox-menu-select"
            onMenuClose={() => setIsOpen(false)}
            onBlur={() => setIsOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default InboxMenu;
